import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get('/auth/me')
      .then(({ data }) => { if (mounted) setAdmin(data.admin); })
      .catch(() => { if (mounted) setAdmin(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const login = (adminData) => {
    setAdmin(adminData);
  };

  const logout = () => {
    api.post('/auth/logout').catch(() => {});
    setAdmin(null);
    localStorage.removeItem('hse_admin');
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
